import { handleActions } from '@housinganywhere/safe-redux';
import { FetchStatus } from 'ha/types/FetchStatus';

import {
  ActionsUnionType as FetchSupportedCountriesActions,
  ActionTypes as FetchSupportedCountriesActionTypes,
} from '../actions/fetchSupportedCountries';
import {
  ActionsUnionType as FetchSupportedCurrenciesActions,
  ActionTypes as FetchSupportedCurrenciesActionTypes,
} from '../actions/fetchSupportedCurrencies';

export interface AppSettingsState {
  supportedCountriesFetchStatus: FetchStatus;
  supportedCurrenciesFetchStatus: FetchStatus;
  supportedCountries: string[];
  supportedCurrencies: string[];
}

export const initialState: AppSettingsState = {
  supportedCountriesFetchStatus: 'loadingFirstTime',
  supportedCurrenciesFetchStatus: 'loadingFirstTime',
  supportedCountries: [],
  supportedCurrencies: [],
};

type ActionTypes =
  | FetchSupportedCountriesActionTypes
  | FetchSupportedCurrenciesActionTypes;
type Actions = FetchSupportedCountriesActions | FetchSupportedCurrenciesActions;

const reducer = handleActions<AppSettingsState, ActionTypes, Actions>(
  {
    [FetchSupportedCountriesActionTypes.START]: state => ({
      ...state,
      supportedCountriesFetchStatus: 'loading',
    }),
    [FetchSupportedCountriesActionTypes.DONE]: (
      state,
      { payload: countries },
    ) => ({
      ...state,
      supportedCountriesFetchStatus: 'success',
      supportedCountries: countries,
    }),
    [FetchSupportedCountriesActionTypes.FAIL]: state => ({
      ...state,
      supportedCountriesFetchStatus: 'failure',
    }),

    [FetchSupportedCurrenciesActionTypes.START]: state => ({
      ...state,
      supportedCurrenciesFetchStatus: 'loading',
    }),
    [FetchSupportedCurrenciesActionTypes.DONE]: (
      state,
      { payload: currencies },
    ) => ({
      ...state,
      supportedCurrenciesFetchStatus: 'success',
      supportedCurrencies: currencies,
    }),
    [FetchSupportedCurrenciesActionTypes.FAIL]: state => ({
      ...state,
      supportedCurrenciesFetchStatus: 'failure',
    }),
  },
  initialState,
);

export default reducer;
